import { ChargerForm, SelectOption } from "@/@types";
import { ChargerEntity } from "@/domain/entities";
import { formatCurrency } from "@/utils";
import moment from "moment";
import { Connector } from "./Connector";
import { Partnership } from "./Partnership";

export interface IoTChannel {
  id: string;
  charger_id: string;
  channel_type: string;
  gpio_pin: number;
  led_count: number;
  day_mode_start: string;
  night_mode_start: string;
  brightness_idle_day: number;
  brightness_idle_night: number;
  brightness_use_day: number;
  brightness_use_night: number;
  color: string;
  enabled: boolean;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

export class Charger {
  id: string;
  location_title: string = "";
  connectors_count: number = 0;
  sessions_count: number = 0;
  incomes: string = "R$0,00";
  connectors_statuses: string[] = [];
  connectors: Connector[] = [];
  created_at: string;
  connectors_ids: SelectOption[] = [];
  ocpp_id: string;
  partnership?: Partnership;
  entity?: Partial<ChargerEntity>;
  last_heartbeat_date?: string = "";
  charger_vendor?: string;
  charger_model?: string;
  firmware_version?: string;
  firmware_update_date?: string | null;
  iccid?: string;
  imsi?: string;
  meter_serial_number?: string | null;
  ocpp_ws_url?: string;
  iot_channels?: IoTChannel[];

  constructor(charger: ChargerEntity) {
    this.id = charger.id;
    this.entity = charger;
    this.sessions_count = charger.sessions_count || 0;
    this.created_at = moment(charger.created_at).format("DD/MM/YYYY");
    this.ocpp_id = charger.ocpp_id;

    this.charger_vendor = charger.charger_vendor || "";
    this.charger_model = charger.charger_model || "";
    this.firmware_version = charger.firmware_version || "";
    this.firmware_update_date = charger.firmware_update_date || "";
    this.iccid = charger.iccid || "";
    this.imsi = charger.imsi || "";
    this.meter_serial_number = charger.meter_serial_number || "";
    this.ocpp_ws_url = charger.ocpp_ws_url || "";

    if (charger.location) {
      this.location_title = charger.location?.title;
    }
    if (charger.sessions_sum_value) {
      this.incomes = formatCurrency(charger.sessions_sum_value);
    }
    if (charger.connectors) {
      this.connectors_count = charger.connectors.length;
      this.connectors_statuses = Connector.formatStatuses(charger.connectors);
      this.connectors = charger.connectors.map((elem) => new Connector(elem));
      this.connectors_ids = charger.connectors.map((elem) => ({
        value: elem.connector_id,
        label: elem.connector_id,
      }));
    }
    if (charger.last_heartbeat_date) {
      this.last_heartbeat_date = moment(charger.last_heartbeat_date).format(
        "DD/MM/YYYY"
      );
    }

    if (charger.location?.partnership) {
      this.partnership = new Partnership(charger.location.partnership);
    }

    if (charger.iot_channels) {
      this.iot_channels = charger.iot_channels;
    }
  }

  static empty: Charger = {
    id: "",
    location_title: "",
    connectors_count: 0,
    sessions_count: 0,
    incomes: "",
    connectors_statuses: [],
    connectors: [],
    last_heartbeat_date: "",
    charger_vendor: "",
    charger_model: "",
    firmware_version: "",
    firmware_update_date: "",
    partnership: Partnership.empty,
    iccid: "",
    imsi: "",
    meter_serial_number: "",
    created_at: "",
    connectors_ids: [],
    ocpp_ws_url: "",
    ocpp_id: "",
    iot_channels: [],
  };

  static emptyForm: ChargerForm = {
    ocpp_id: "",
    location_id: "",
    connectors: [
      {
        id: "",
        connector_id: "1",
        type: "",
        pricing_profile_id: "",
        current_type: "",
        charging_speed_type: "",
        max_charging_speed: "",
      },
    ],
  };
}
